import { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { Button, Checkbox, DatePicker, Form, Image, Input, Layout, message, Modal, Radio, Select, Space, Switch, Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import { pageFormItemLayout, pageFormItemWithoutLabelGridLayout } from '@utils/property';
import config from '@config';
import { isEmpty } from '@utils/utils';
import { addProjestsApi, editProjestsApi, getProjestsApi, getProjestsGroupListApi, selectionUploadFile } from '@services/Selection';
import competationImg from '@static/images/competation.png';
import judgeImg from '@static/images/judge.png';
import cerificate from '@static/images/cerificate.jpeg';
import './Project.less';
import { getBannerColor, prepareBCOSSUrl } from '../../../utils/utils';
import PageHeader from '@components/PageHeader/PageHeader';
import RichEditor, { isEffectivelyEmptyRichHtml } from '@components/common/RichEditor';
import { closePageTabByKey } from '@/hooks/useSyncedPageTabs';
import { workspaceSelectionInfoPath, workspaceSelectionRootPath } from '@/layouts/selectionWorkspacePaths';
const Project = () => {
    const params = useParams();
    const navigate = useNavigate();
    const workspaceProjectId = params?.pid && params.pid !== 'new' ? Number(params.pid) : 0;
    const id = ~~params?.id || workspaceProjectId || 0;

    const [form] = Form.useForm();

    const option = { headers: { 'Content-Type': 'multipart/form-data' } };

    const [projectsGroupList, setProjectsGroupList] = useState([]);
    const [coverList, setCoverList] = useState([]);
    const [oneData, setOneData] = useState(false);
    const [switchList, setSwitchList] = useState({ zoneOn: false });
    const [openRule, setOpenRule] = useState(2);
    const [titleName, setTitleName] = useState('');
    const [topicCount, setTopicCount] = useState(0);
    const [topicCaseNumCount, setTopicCaseNumCount] = useState(0);
    const [competitionList, setCompetitionList] = useState([]);
    const [judgesList, setJudgesList] = useState([]);
    const [certifiList, setCertifiList] = useState([]);
    const [isShowTemplate, setIsShowTemplate] = useState(false);
    const templateType = useRef(1);

    const [bannerUrlList, setBannerUrlList] = useState([]);
    const [h5BannerUrlList, setH5BannerUrlList] = useState([]);
    const bannerBgColor = useRef(null);

    const [fileList, setFileList] = useState([]); // 分享图
    const [descriptionContent, setDescriptionContent] = useState('');

    const openRuleField = Form.useWatch('openRule', form);
    const aiReviewEnabledWatch = Form.useWatch(['aiReviewSettings', 'enabled'], form);
    const aiReviewPageLimitOnWatch = Form.useWatch(['aiReviewSettings', 'pageLimitOn'], form);
    const aiReviewTemplateOnWatch = Form.useWatch(['aiReviewSettings', 'templateOn'], form);
    const aiReviewTemplatePathWatch = Form.useWatch(['aiReviewSettings', 'template'], form);
    const projectNameWatch = Form.useWatch('name', form);

    const normalizeAiReviewSettingsForForm = s => {
        let parsed = s;
        if (typeof s === 'string') {
            const t = s.trim();
            if (t === '' || t === 'null') {
                parsed = null;
            } else {
                try {
                    parsed = JSON.parse(s);
                } catch {
                    parsed = null;
                }
            }
        }
        if (!parsed) {
            return {
                enabled: false,
                pageLimitOn: false,
                pageNumMin: undefined,
                pageNumMax: undefined,
                templateOn: false,
                template: '',
                duplicateOn: false,
            };
        }
        if (!parsed.enabled) {
            return {
                enabled: false,
                pageLimitOn: false,
                pageNumMin: undefined,
                pageNumMax: undefined,
                templateOn: false,
                template: '',
                duplicateOn: false,
            };
        }
        return {
            enabled: true,
            pageLimitOn: parsed.page_num != null && parsed.page_num !== undefined,
            pageNumMin: parsed.page_num?.min,
            pageNumMax: parsed.page_num?.max,
            templateOn: !!parsed.template,
            template: parsed.template || '',
            duplicateOn: !!parsed.duplicate,
        };
    };

    const buildAiReviewSettingsPayload = formVals => {
        if (!formVals || !formVals.enabled) {
            return null;
        }
        const pageLimitOn = !!formVals.pageLimitOn;
        const templateOn = !!formVals.templateOn;
        const duplicateOn = !!formVals.duplicateOn;
        if (!pageLimitOn && !templateOn && !duplicateOn) {
            return null;
        }
        return {
            enabled: true,
            page_num: pageLimitOn
                ? {
                      min: Number(formVals.pageNumMin),
                      max: Number(formVals.pageNumMax),
                  }
                : null,
            template: templateOn ? formVals.template || '' : null,
            duplicate: duplicateOn,
        };
    };

    const checkImgUploadFile = (file, sizeMb) => {
        const typeList = ['image/jpg', 'image/jpeg', 'image/png'];
        const isImage = typeList.includes(file.type) || false;

        if (!isImage) {
            message.error('仅支持 JPG/PNG 图片格式');
            return false;
        }

        const metSize = file.size / 1024 / 1024 < sizeMb;
        if (!metSize) {
            message.error(`图片文件大小限${sizeMb}MB`);
            return false;
        }

        return isImage && metSize;
    };

    const onDescriptionChange = v => {
        setDescriptionContent(v);
        form.setFieldValue('description', v);
        if (!isEffectivelyEmptyRichHtml(v)) {
            form.setFields([{ name: 'description', errors: null }]);
        }
    };

    const descriptionImageUploadHandler = useCallback(async blobInfo => {
        const formData = new FormData();
        formData.append('file', blobInfo.blob());
        formData.append('type', 13);

        const res = await selectionUploadFile(formData);
        if (!res || res.status_code !== 200) {
            throw new Error('图片上传失败');
        }
        return prepareBCOSSUrl(res.data);
    }, []);

    const uploadImageFile = (fileInfo, type) => {
        // type = 13 selection
        const formData = new FormData();
        formData.append('file', fileInfo.file);
        formData.append('type', 13);

        selectionUploadFile(formData).then(async res => {
            if (!res) {
                message.error('文件上传失败');
                return false;
            }

            if (res.status_code === 200) {
                const url = prepareBCOSSUrl(res.data);
                if (type === 'banner') {
                    setBannerUrlList([url]);
                    form.setFieldValue('banner', res.data);
                    bannerBgColor.current = await getBannerColor(url);
                } else if (type === 'h5Banner') {
                    setH5BannerUrlList([url]);
                    form.setFieldValue('h5Banner', res.data);
                }
            }
        });
    };

    const onFinish = values => {
        if (values.openRule !== 1) {
            if (isEmpty(values.orgAuthRule) && isEmpty(values.personalAuthRule)) {
                form.setFields([{ name: 'orgAuthRule', errors: ['职务认证或机构认证，满足认证要求可投稿'] }]);
                return;
            }
        }

        const ar = values.aiReviewSettings;
        if (ar?.enabled) {
            const hasAny = ar.pageLimitOn || ar.templateOn || ar.duplicateOn;
            if (!hasAny) {
                message.error('开启 AI 初审时，请至少选择实践页数、实践模板或实践重复中的一项限制。');
                return;
            }
            if (ar.pageLimitOn) {
                const min = Number(ar.pageNumMin);
                const max = Number(ar.pageNumMax);
                if (!Number.isFinite(min) || !Number.isFinite(max) || !Number.isInteger(min) || !Number.isInteger(max) || min < 1 || max < 1 || max < min) {
                    message.error('请填写有效的实践页数范围（正整数，且最大值不小于最小值）');
                    return;
                }
            }
            if (ar.templateOn && !String(ar.template || '').trim()) {
                message.error('已开启实践模板限制时，请上传模板文件');
                return;
            }
        }

        // 将 caseInfoShow 数组转换为对象格式
        const caseInfoShowObj = {};
        if (values.caseInfoShow && Array.isArray(values.caseInfoShow)) {
            values.caseInfoShow.forEach(item => {
                caseInfoShowObj[item] = 1;
            });
        }

        const { aiReviewSettings: aiReviewForm, ...restValues } = values;

        const body = {
            ...restValues,
            startedAt: dayjs(values.projectsDate[0]).format('YYYY-MM-DD'),
            endedAt: dayjs(values.projectsDate[1]).format('YYYY-MM-DD'),
            openStartedAt: dayjs(values.contributeDate[0]).format('YYYY-MM-DD HH:mm:ss'),
            openEndedAt: dayjs(values.contributeDate[1]).format('YYYY-MM-DD HH:mm:ss'),
            caseFileShow: 1,
            caseBaseInfoShow: 1,
            caseInfoShow: JSON.stringify(caseInfoShowObj), // 使用 JSON 字符串格式
            zoneOn: values.zoneOn ? 1 : 0,
            regions: JSON.stringify(values.regions),
            topicVoteLimit: values.topicVoteLimit === 0 ? 0 : values.edit || 0,
            topicCaseNumLimit: values.topicCaseNumLimit === 0 ? 0 : values.topicCaseNumEdit || 0,
            dailyMultiVoteEnabled: values.dailyMultiVoteEnabled ? 1 : 0,
            contactsConfirmed: values.contactsConfirmed ? 1 : 0,
            bannerBgColor: bannerBgColor.current || '',
            aiReviewSettings: (() => {
                const payload = buildAiReviewSettingsPayload(aiReviewForm);
                return payload === null ? null : JSON.stringify(payload);
            })(),
        };
        delete body.projectsDate;
        delete body.contributeDate;
        delete body.edit;
        delete body.topicCaseNumEdit;

        if (values.openRule !== 1) {
            body.orgAuthRule = JSON.stringify(values.orgAuthRule);
            body.personalAuthRule = JSON.stringify(values.personalAuthRule);
        }

        console.log(body);

        if (id) {
            body.id = id;
            editProjestsApi(body).then(res => {
                if (res.status_code === 200) {
                    message.success(res.message);
                    navigate(workspaceSelectionInfoPath(id));
                }
            });
        } else {
            addProjestsApi(body).then(res => {
                if (res.status_code === 200) {
                    message.success(res.message);
                    navigate(workspaceSelectionRootPath(res?.data?.id || 'new'));
                }
            });
        }
    };

    const onReset = () => {
        if (!id) {
            closePageTabByKey('/selection/projects/new');
        }
        navigate('/selection/projects');
    };

    const filterOption = (input, option) => {
        const { groupName } = option.props.data;
        return groupName.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    useEffect(() => {
        if (id) {
            getProjestsApi({ id }).then(async res => {
                if (res.status_code === 200) {
                    const { data } = res || {};

                    setSwitchList({
                        zoneOn: data.zoneOn,
                    });
                    setOpenRule(data.openRule);
                    setTitleName(data.name);
                    setTopicCount(data.topicVoteLimit ? 1 : 0);
                    setTopicCaseNumCount(data.topicCaseNumLimit ? 1 : 0);
                    res.data.coverPath ? setCoverList([data.coverPath]) : setCoverList([]);
                    res.data.competitionCertificateUrl ? setCompetitionList([data.competitionCertificateUrl]) : setCompetitionList([]);
                    res.data.judgesAppointmentUrl ? setJudgesList([data.judgesAppointmentUrl]) : setJudgesList([]);
                    res.data.awardCertificateTemplate ? setCertifiList([data.awardCertificateTemplate]) : setCertifiList([]);
                    res.data.sharePic ? setFileList([data.sharePic]) : setFileList([]);

                    if (res.data.banner) {
                        setBannerUrlList([prepareBCOSSUrl(res.data.banner)]);
                    }
                    if (res.data.h5Banner) {
                        setH5BannerUrlList([prepareBCOSSUrl(res.data.h5Banner)]);
                    }
                    if (res.data.banner) {
                        const url = prepareBCOSSUrl(res.data.banner);
                        const bgColor = await getBannerColor(url);
                        bannerBgColor.current = bgColor;
                    }

                    setDescriptionContent(data.description || '');

                    form.setFieldsValue({
                        ...data,
                        projectsDate: [dayjs(data.startedAt), dayjs(data.endedAt)],
                        contributeDate: data.openStartedAt && data.openEndedAt ? [dayjs(data.openStartedAt), dayjs(data.openEndedAt)] : null,
                        regions: data.zoneOn ? JSON.parse(data?.regions || '[]') : [],
                        topicVoteLimit: data.topicVoteLimit ? 1 : 0,
                        edit: data?.topicVoteLimit ? data.topicVoteLimit : '',
                        topicCaseNumLimit: data.topicCaseNumLimit ? 1 : 0,
                        topicCaseNumEdit: data?.topicCaseNumLimit ? data.topicCaseNumLimit : '',
                        voteWaitDuration: data?.voteWaitDuration ? data.voteWaitDuration : 0,
                        dailyVoteLimit: data?.dailyVoteLimit ? data.dailyVoteLimit : 1,
                        dailyMultiVoteEnabled: data?.dailyMultiVoteEnabled ? true : false,
                        contactsConfirmed: !!data?.contactsConfirmed,
                        orgAuthRule: data.openRule !== 1 ? JSON.parse(data?.orgAuthRule) : ['A01', 'A06', 'A02', 'A04', 'A03'],
                        personalAuthRule: data.openRule !== 1 ? JSON.parse(data?.personalAuthRule) : ['2', '1', '0', '3'],
                        // 将 caseInfoShow JSON 字符串解析后转换为数组格式用于表单反显
                        caseInfoShow: (() => {
                            if (!data.caseInfoShow) return ['basicInfo'];
                            try {
                                const parsed = JSON.parse(data.caseInfoShow);
                                return Object.keys(parsed).filter(key => parsed[key] === 1);
                            } catch (e) {
                                return ['basicInfo'];
                            }
                        })(),
                        aiReviewSettings: normalizeAiReviewSettingsForForm(data.aiReviewSettings),
                    });

                    console.log(form.getFieldsValue());
                }
            });
        } else {
            form.setFieldsValue({
                ...switchList,
                caseInfoShow: ['basicInfo'], // 默认值改为 basicInfo
                aiReviewSettings: normalizeAiReviewSettingsForForm(null),
            });
        }

        //获取评议项目组
        getProjestsGroupListApi().then(res => {
            if (res && res.status_code === 200) {
                setProjectsGroupList(res.data);
            }
        });
    }, []);

    useEffect(() => {
        document.title = (id ? '编辑评议项目' : '新增评议项目') + '-医评议';
    }, []);

    // 获取上传文件 - 前缀
    const getFileUrl = url => {
        if (url && url.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return config.OSS_PREFIX + url;
        }
        return null;
    };

    const checkout = (file, size, initWidth, initHeight) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        // 判断类型
        if (!isJpgOrPng) {
            message.error('只能上传 jpg/png/jpeg 格式');
            setOneData(true);
            return null;
        } else {
            setOneData(false);
        }
        // 判断大小
        const isLt2M = file.size / 1024 / 1024 < size;
        if (!isLt2M) {
            message.error('图像必须小于' + size + 'MB!');
            setOneData(true);
            return null;
        } else {
            setOneData(false);
        }
        return isJpgOrPng && isLt2M;
    };

    const beforeCropCheck = (file, bool, size, type) => {
        if (file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/jpeg') {
            message.error('只支持JPG/JPEG/PNG格式。');
            return null;
        }

        if (file.size > size * 1024 * 1024) {
            message.error(`图片大小不能超过${size}MB。`);
            return null;
        }

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = event => {
                const res = event.target.result;
                const imgDom = document.createElement('img');
                imgDom.src = res;
                imgDom.onload = () => {
                    if (type === 'bg') {
                        if (imgDom.width < 1754 || imgDom.height < 1240) {
                            bool && message.warning('证书背景不小于1754×1240px。');
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    } else {
                        if (imgDom.width < 750 || imgDom.height < 422) {
                            bool && message.warning('图片大小不小于750×422px。');
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                };
            };
            reader.readAsDataURL(file);
        });
    };

    const swapItems = (arr, index1, index2) => {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0];
        return arr;
    };

    // 上移
    const upData = index => {
        const arr = form.getFieldValue('regions');
        let newArr = [];
        if (arr.length > 1 && index !== 0) {
            newArr = [...swapItems(arr, index, index - 1)];
        }
        form.setFieldValue('regions', newArr);
    };

    // 下移
    const downData = index => {
        const arr = form.getFieldValue('regions');
        let newArr = [];
        if (arr.length > 1 && index !== arr.length - 1) {
            newArr = [...swapItems(arr, index, index + 1)];
        }
        form.setFieldValue('regions', newArr);
    };

    // 封面上传
    const coverImageFile = {
        name: 'coverImageFile',
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 13);
            if (!oneData) {
                selectionUploadFile(formData).then(res => {
                    if (!res) {
                        message.error('上传文件失败！！');
                        return false;
                    }
                    if (res.status_code === 200) {
                        setCoverList([getFileUrl(res.data)]);
                        form.setFieldValue('coverPath', getFileUrl(res.data));
                        form.setFields([{ name: 'coverPath', errors: null }]);
                    }
                });
            } else {
                form.setFieldValue('coverPath', undefined);
            }
        },
    };

    // 实践申报证书背景图上传
    const competitionImageFile = {
        name: 'competitionImageFile',
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 13);
            if (!oneData) {
                selectionUploadFile(formData).then(res => {
                    if (!res) {
                        message.error('上传文件失败！！');
                        return false;
                    }
                    if (res.status_code === 200) {
                        setCompetitionList([getFileUrl(res.data)]);
                        form.setFieldValue('competitionCertificateUrl', getFileUrl(res.data));
                        form.setFields([{ name: 'competitionCertificateUrl', errors: null }]);
                    }
                });
            } else {
                form.setFieldValue('competitionCertificateUrl', undefined);
            }
        },
    };

    // 专家聘书背景图上传
    const judgesImageFile = {
        name: 'judgesImageFile',
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 13);

            if (!oneData) {
                selectionUploadFile(formData).then(res => {
                    if (!res) {
                        message.error('上传文件失败！！');
                        return false;
                    }
                    if (res.status_code === 200) {
                        setJudgesList([getFileUrl(res.data)]);
                        form.setFieldValue('judgesAppointmentUrl', getFileUrl(res.data));
                        form.setFields([{ name: 'judgesAppointmentUrl', errors: null }]);
                    }
                });
            } else {
                form.setFieldValue('judgesAppointmentUrl', undefined);
            }
        },
    };

    // 获奖证书上传
    const certifiFile = {
        name: 'certifiFile',
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 13);
            if (!oneData) {
                selectionUploadFile(formData).then(res => {
                    if (!res) {
                        message.error('上传文件失败！！');
                        return false;
                    }
                    if (res.status_code === 200) {
                        setCertifiList([getFileUrl(res.data)]);
                        form.setFieldValue('awardCertificateTemplate', getFileUrl(res.data));
                        form.setFields([{ name: 'awardCertificateTemplate', errors: null }]);
                    }
                });
            } else {
                form.setFieldValue('awardCertificateTemplate', undefined);
            }
        },
    };

    // 查看示例证书
    const viewTemplateImg = type => {
        templateType.current = type;
        setIsShowTemplate(true);
    };

    // 查看示例证书
    const getViewImg = () => {
        const type = templateType.current;
        if (type === 1) {
            return competationImg;
        }
        if (type === 2) {
            return judgeImg;
        }
        if (type === 3) {
            return cerificate;
        }
    };

    // 关闭图片
    const closeImg = type => {
        if (type === 1) {
            setCompetitionList([]);
            form.setFieldValue('competitionCertificateUrl', '');
        } else if (type === 2) {
            setJudgesList([]);
            form.setFieldValue('judgesAppointmentUrl', '');
        } else {
            setCertifiList([]);
            form.setFieldValue('awardCertificateTemplate', '');
        }
    };

    const handleChangeSwitch = (bool, type) => {
        if (type === 'zoneOn') {
            if (!bool) form.setFieldValue('regions', []);
            setSwitchList({
                ...switchList,
                zoneOn: bool,
            });
        }
    };

    const handleChangeType = e => {
        setOpenRule(e.target.value);
        if (e.target.value && e.target.value === 1) {
            form.setFieldValue('authenticate', {});
        }
        // 当选择非 1 选项时，默认全选认证类型
        if (e.target.value && e.target.value !== 1) {
            form.setFieldValue('personalAuthRule', ['A01', 'A06', 'A02', 'A04', 'A03']);
            form.setFieldValue('orgAuthRule', ['2', '1', '0', '3']);
        }
    };

    const handleChangeRadio = e => {
        const value = e.target.value;
        setTopicCount(value);
        form.setFieldValue('topicVoteLimit', value);
    };

    const handleChangeTopicCaseNumRadio = e => {
        const value = e.target.value;
        setTopicCaseNumCount(value);
        form.setFieldValue('topicCaseNumLimit', value);
    };

    const handleChangeAuth = () => {
        if (form.getFieldValue('openRule') !== 1) {
            if (isEmpty(form.getFieldValue('orgAuthRule')) && isEmpty(form.getFieldValue('personalAuthRule'))) {
                form.setFields([{ name: 'orgAuthRule', errors: ['职务认证或机构认证，满足认证要求可投稿'] }]);
            } else {
                form.setFields([{ name: 'orgAuthRule', errors: null }]);
            }
        }
    };

    // 分享图
    const shareImageFile = {
        name: 'shareImageFile',
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 13);
            if (!oneData) {
                selectionUploadFile(formData, option).then(res => {
                    if (!res) {
                        message.error('上传文件失败！！');
                        return false;
                    }
                    if (res.status_code === 200) {
                        setFileList([getFileUrl(res.data)]);
                        form.setFieldValue('sharePic', getFileUrl(res.data));
                        form.setFields([{ name: 'sharePic', errors: null }]);
                    }
                });
            } else {
                form.setFieldValue('sharePic', undefined);
            }
        },
    };

    const beforeUploadAiReviewTemplate = file => {
        if (!form.getFieldValue(['aiReviewSettings', 'enabled'])) {
            return Upload.LIST_IGNORE;
        }
        if (!form.getFieldValue(['aiReviewSettings', 'templateOn'])) {
            return Upload.LIST_IGNORE;
        }
        const isPptx = file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || /\.pptx$/i.test(file.name || '');
        if (!isPptx) {
            message.error('仅支持 pptx 格式');
            return Upload.LIST_IGNORE;
        }
        const isLt10M = file.size / 1024 / 1024 < 20;
        if (!isLt10M) {
            message.error('文件大小不能超过 20MB');
            return Upload.LIST_IGNORE;
        }
        return true;
    };

    const aiReviewTemplateUpload = {
        name: 'aiReviewTemplateFile',
        customRequest: info => {
            if (!form.getFieldValue(['aiReviewSettings', 'enabled']) || !form.getFieldValue(['aiReviewSettings', 'templateOn'])) {
                return;
            }
            const formData = new FormData();
            formData.append('file', info.file);
            formData.append('type', 13);
            selectionUploadFile(formData).then(res => {
                if (!res) {
                    message.error('上传文件失败');
                    return;
                }
                if (res.status_code === 200) {
                    form.setFieldValue(['aiReviewSettings', 'template'], res.data);
                    message.success('模板上传成功');
                }
            });
        },
    };

    const handleAiReviewEnabledChange = checked => {
        if (!checked) {
            form.setFieldsValue({
                aiReviewSettings: normalizeAiReviewSettingsForForm(null),
            });
        }
    };

    const handleAiReviewPageLimitOnChange = checked => {
        if (!checked) {
            form.setFieldValue(['aiReviewSettings', 'pageLimitOn'], false);
            form.setFieldValue(['aiReviewSettings', 'pageNumMin'], undefined);
            form.setFieldValue(['aiReviewSettings', 'pageNumMax'], undefined);
        }
    };

    const handleAiReviewTemplateOnChange = checked => {
        if (!checked) {
            form.setFieldValue(['aiReviewSettings', 'templateOn'], false);
            form.setFieldValue(['aiReviewSettings', 'template'], '');
        }
    };

    const handleAiReviewDuplicateOnChange = checked => {
        if (!checked) {
            form.setFieldValue(['aiReviewSettings', 'duplicateOn'], false);
        }
    };

    const handleAiReviewTemplateDownload = e => {
        e.preventDefault();
        const url = prepareBCOSSUrl(aiReviewTemplatePathWatch);
        if (!url) {
            return;
        }
        const rawName = (projectNameWatch && String(projectNameWatch).trim()) || '未命名项目';
        const safeBase = rawName.replace(/[/\\?%*:|"<>]/g, '_');
        const path = String(aiReviewTemplatePathWatch || '');
        const extMatch = path.match(/\.([a-z0-9]+)$/i);
        const ext = extMatch ? `.${extMatch[1].toLowerCase()}` : '.pptx';
        const filename = `${safeBase}_实践模板${ext}`;

        fetch(url)
            .then(r => {
                if (!r.ok) {
                    throw new Error();
                }
                return r.blob();
            })
            .then(blob => {
                const objectUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = objectUrl;
                a.download = filename;
                a.click();
                URL.revokeObjectURL(objectUrl);
            })
            .catch(() => {
                window.open(url, '_blank', 'noopener,noreferrer');
            });
    };

    // 实践申报限制勾选认证时，默认全部勾选认证类型
    // useEffect(() => {
    //     if (openRuleField === 2 || openRuleField === 3) {
    //         form.setFieldValue("personalAuthRule", ['A01', 'A06','A02','A04','A03']);
    //         form.setFieldValue("orgAuthRule", ['2', '1','0','3']);
    //     } else {
    //         form.setFieldValue("personalAuthRule", undefined);
    //         form.setFieldValue("orgAuthRule", undefined);
    //     }
    // }, [openRuleField]);

    return (
        <Fragment>
            <PageHeader title={!id ? '新增评议项目' : '编辑评议项目'} breadcrumb={[{ label: '评议项目', path: '/selection/projects' }, { label: !id ? '新增评议项目' : '编辑评议项目' }]} />

            <div className="page-route-body">
                <Form
                    className="projects-form"
                    {...pageFormItemLayout}
                    form={form}
                    onFinish={onFinish}
                    initialValues={{
                        voteWaitDuration: 0,
                        dailyVoteLimit: 1,
                        dailyMultiVoteEnabled: false,
                        topicVoteLimit: 0,
                        topicCaseNumLimit: 0,
                        contactsConfirmed: true,
                        aiReviewSettings: {
                            enabled: false,
                            pageLimitOn: false,
                            pageNumMin: undefined,
                            pageNumMax: undefined,
                            templateOn: false,
                            template: '',
                            duplicateOn: false,
                        },
                    }}
                >
                    <Form.Item name="h3yunNo" label="氚云编号" rules={[{ required: true, message: '' }]}>
                        <Input placeholder="输入氚云编号" maxLength={100} allowClear />
                    </Form.Item>
                    <Form.Item
                        name="name"
                        label="项目名称"
                        rules={[
                            { required: true, message: '请输入评议项目名称' },
                            { min: 2, message: '请输入评议项目名称，限2-50个字符' },
                        ]}
                    >
                        <Input placeholder="输入评议项目名称" maxLength={50} showCount allowClear />
                    </Form.Item>

                    <Form.Item name="groupId" label="所属项目组" rules={[{ required: true, message: '请选择所属评议项目组' }]}>
                        <Select showSearch={{ optionFilterProp: 'children', filterOption: filterOption }} placeholder="请选择所属评议项目组">
                            {projectsGroupList
                                && projectsGroupList.map(item => (
                                    <Select.Option key={item.id} value={item.id} data={item}>
                                        {item.groupName}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="slug"
                        label="短网址"
                        rules={[
                            { required: true, message: '' },
                            { pattern: /^[a-z\d_\d-]{2,20}$/, message: '短网址不符合格式要求' },
                        ]}
                        help="评议项目短网址，如 chc-s8，小写字母、数字、连字符（-）或下划线（_），限2-20个字符"
                    >
                        <Input placeholder="请输入评议项目短网址" maxLength={20} showCount allowClear />
                    </Form.Item>

                    <Form.Item name="projectsDate" label="项目起止日期" rules={[{ required: true, message: '请选择项目起止日期' }]}>
                        <DatePicker.RangePicker />
                    </Form.Item>

                    <Form.Item name="coverPath" label="封面图" rules={[{ required: true, message: '' }]} help="图片尺寸 750*422px，支持 JPG/PNG格式，大小不超过2MB" className="share-image">
                        {coverList.length > 0 && <Image width={200} src={coverList[0]} className="share-image-area" alt="封面图预览" />}

                        <div>
                            <ImgCrop
                                aspect={16 / 9}
                                minZoom={0.1}
                                maxZoom={2}
                                quality={1}
                                beforeCrop={async file => {
                                    const res = await beforeCropCheck(file, true, 2);
                                    return res;
                                }}
                            >
                                <Upload beforeUpload={file => checkout(file, 2, 300, 300)} fileList={coverList} {...coverImageFile} maxCount={1}>
                                    <Button icon={<i className="bi bi-upload" />}>{coverList.length > 0 ? '更改图片' : '上传图片'}</Button>
                                </Upload>
                            </ImgCrop>
                        </div>
                    </Form.Item>

                    <Form.Item name="banner" label="PC端项目主图" rules={[{ required: true, message: '' }]} help="支持JPG/PNG格式，建议尺寸 3840&times;900px，文件大小不超过2MB">
                        {bannerUrlList && bannerUrlList.length > 0 && (
                            <div className="uploaded-image" style={{ marginBottom: 8 }}>
                                <Image src={bannerUrlList[0]} alt="PC端项目主图预览" />
                            </div>
                        )}

                        <Upload beforeUpload={file => checkImgUploadFile(file, 2)} fileList={[]} customRequest={fileInfo => uploadImageFile(fileInfo, 'banner')}>
                            <Button
                                icon={
                                    <span className="anticon">
                                        <i className="bi bi-upload"></i>
                                    </span>
                                }
                            >
                                {bannerUrlList && bannerUrlList.length > 0 ? '更改图片' : '上传图片'}
                            </Button>
                        </Upload>
                    </Form.Item>

                    <Form.Item name="h5Banner" label="移动端项目主图" rules={[{ required: true, message: '' }]} help="支持JPG/PNG格式，建议尺寸 1500&times;900px，文件大小不超1MB">
                        {h5BannerUrlList && h5BannerUrlList.length > 0 && (
                            <div className="uploaded-image projects-h5-banner-preview" style={{ marginBottom: 8 }}>
                                <Image width={375} src={h5BannerUrlList[0]} alt="移动端项目主图预览" />
                            </div>
                        )}

                        <Upload beforeUpload={file => checkImgUploadFile(file, 1)} fileList={[]} customRequest={fileInfo => uploadImageFile(fileInfo, 'h5Banner')}>
                            <Button
                                icon={
                                    <span className="anticon">
                                        <i className="bi bi-upload"></i>
                                    </span>
                                }
                            >
                                {h5BannerUrlList && h5BannerUrlList.length > 0 ? '更改图片' : '上传图片'}
                            </Button>
                        </Upload>
                    </Form.Item>

                    <Form.Item
                        name="description"
                        label="项目简介"
                        rules={[
                            {
                                validator: async (_, value) => {
                                    if (isEffectivelyEmptyRichHtml(value)) {
                                        return Promise.reject(new Error('请输入项目简介'));
                                    }
                                },
                            },
                        ]}
                    >
                        <RichEditor id="selection-project-description" mode="standard" height={200} value={descriptionContent ?? ''} onChange={onDescriptionChange} imageUploadHandler={descriptionImageUploadHandler} className="react-editor" />
                    </Form.Item>

                    <Form.Item name="zoneOn" label="启用区域">
                        <Switch checkedChildren="开" unCheckedChildren="关" checked={switchList.zoneOn} onChange={e => handleChangeSwitch(e, 'zoneOn')} />
                    </Form.Item>

                    {switchList.zoneOn && (
                        <Form.Item label="划分区域" rules={[{ required: true, message: '请添加区域' }]} name="regions">
                            <Form.List name="regions" className="projects-race-form-list">
                                {(fields, { add, remove }) => (
                                    <Fragment>
                                        <Form.Item
                                            style={{
                                                marginBottom: '10px',
                                            }}
                                        >
                                            <Button type="link" size="small" disabled={fields?.length >= 20} onClick={() => add()}>
                                                <i className="bi bi-plus-circle" />
                                                添加区域
                                            </Button>
                                        </Form.Item>
                                        {fields.map(({ key, name, ...restFields }, index) => (
                                            <Space key={key} align="start" className="projects-race-form-list-space">
                                                <Form.Item
                                                    {...restFields}
                                                    name={[name, 'name']}
                                                    rules={[{ required: true, message: '请输入区域名称' }]}
                                                    style={{
                                                        marginBottom: 0,
                                                    }}
                                                >
                                                    <Input placeholder="区域名称" />
                                                </Form.Item>
                                                <Form.Item
                                                    {...restFields}
                                                    name={[name, 'desc']}
                                                    rules={[{ required: true, message: '请输入区域说明' }]}
                                                    style={{
                                                        marginBottom: 0,
                                                    }}
                                                >
                                                    <Input placeholder="区域说明" className="raceDesc-input" />
                                                </Form.Item>
                                                {index !== 0 && (
                                                    <div className="projects-icon-main">
                                                        <i className="bi bi-arrow-up-circle icon-pointer-projects" onClick={() => upData(index)}></i>
                                                        <div className="icon-title-projects" onClick={() => upData(index)}>
                                                            上移
                                                        </div>
                                                    </div>
                                                )}

                                                {index !== fields.length - 1 && (
                                                    <div className="projects-icon-main">
                                                        <i className="bi bi-arrow-down-circle icon-pointer-projects" onClick={() => downData(index)}></i>
                                                        <div className="icon-title-projects" onClick={() => downData(index)}>
                                                            下移
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="projects-icon-main">
                                                    <i className="bi bi-x-circle icon-pointer-projects" onClick={() => remove(name)}></i>
                                                    <div className="icon-title-projects" onClick={() => remove(index)}>
                                                        移除
                                                    </div>
                                                </div>
                                            </Space>
                                        ))}
                                    </Fragment>
                                )}
                            </Form.List>
                        </Form.Item>
                    )}

                    <Form.Item name="contributeDate" label="实践申报时间" rules={[{ required: true, message: '请选择实践申报时间' }]}>
                        <DatePicker.RangePicker showTime />
                    </Form.Item>

                    <Form.Item name="openRule" label="申报人及干系人限制" help="完成专业认证可申报：用户需通过认证审核才可申报实践；提交专业认证信息可申报：用户提交专业认证信息即可申报实践" rules={[{ required: true, message: '' }]}>
                        <Radio.Group value={openRule} onChange={handleChangeType}>
                            <Radio value={2}>完成专业认证可申报</Radio>
                            <Radio value={3}>提交专业认证信息可申报</Radio>
                            <Radio value={1}>完成注册可申报</Radio>
                        </Radio.Group>
                    </Form.Item>

                    {openRule && openRule !== 1 && (
                        <Form.Item
                            label="申报人及干系人认证限制"
                            className="required"
                            // rules={[{ required: true }]}
                            help="职务认证或机构认证，满足认证要求可投稿"
                        >
                            <div className="radio-list">
                                <div className="field-group">
                                    <span className="field-title">职务认证：</span>
                                    <Form.Item
                                        name="personalAuthRule"
                                        // rules={[{ required: true }]}
                                        noStyle
                                    >
                                        <Checkbox.Group
                                            onChange={handleChangeAuth}
                                            options={[
                                                { label: '医疗机构从业者', value: 'A01' },
                                                { label: '社会团队人士', value: 'A06' },
                                                { label: '政府官员', value: 'A02' },
                                                { label: '教育科研人士', value: 'A04' },
                                                { label: '商业人士', value: 'A03' },
                                            ]}
                                        />
                                    </Form.Item>
                                </div>
                                <div className="field-group">
                                    <span className="field-title">机构认证：</span>
                                    <Form.Item
                                        name="orgAuthRule"
                                        noStyle
                                        // rules={[{ required: true }]}
                                    >
                                        <Checkbox.Group
                                            onChange={handleChangeAuth}
                                            options={[
                                                { label: '医疗机构', value: '2' },
                                                { label: '媒体', value: '1' },
                                                { label: '企业', value: '0' },
                                                { label: '机构', value: '3' },
                                            ]}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        </Form.Item>
                    )}

                    <Form.Item name="contactsConfirmed" label="负责人确认后再审核" valuePropName="checked" extra="开启后，该材料负责人确认后，平台才可进行人工审核">
                        <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                    </Form.Item>

                    <Form.Item name="caseInfoShow" label="实践详情展示" rules={[{ required: true, message: '请至少勾选一项展示' }]} extra="勾选字段将显示在详情页，至少勾选一项展示">
                        <Checkbox.Group
                            options={[
                                { label: '申报信息', value: 'basicInfo' },
                                { label: '成果壁报', value: 'poster' },
                                { label: '文档', value: 'caseDoc' },
                                { label: '图片', value: 'caseImage' },
                                { label: '视频', value: 'caseVideo' },
                            ]}
                        />
                    </Form.Item>

                    <Form.Item label="AI 初审" required={false}>
                        <div>
                            <Space align="start" wrap>
                                <Form.Item name={['aiReviewSettings', 'enabled']} valuePropName="checked" noStyle>
                                    <Switch checkedChildren="开启" unCheckedChildren="关闭" onChange={handleAiReviewEnabledChange} />
                                </Form.Item>
                            </Space>
                            <div className="ant-form-item-extra" style={{ marginTop: 4, clear: 'both' }}>
                                开启后，系统将使用AI初审实践，给出审核参考结果；请至少选择实践页数、实践模板或实践重复中的一项限制。
                            </div>
                            <div
                                style={{
                                    display: aiReviewEnabledWatch ? 'block' : 'none',
                                    marginTop: 12,
                                    paddingLeft: 16,
                                    borderLeft: '2px solid #f0f0f0',
                                }}
                                aria-hidden={!aiReviewEnabledWatch}
                            >
                                <div style={{ marginBottom: 12 }}>
                                    <Space align="center" wrap>
                                        <Form.Item name={['aiReviewSettings', 'pageLimitOn']} valuePropName="checked" noStyle>
                                            <Switch checkedChildren="开启" unCheckedChildren="关闭" onChange={handleAiReviewPageLimitOnChange} />
                                        </Form.Item>
                                        <span>实践页数限制：</span>
                                        <Form.Item name={['aiReviewSettings', 'pageNumMin']} noStyle>
                                            <Input style={{ width: 72 }} placeholder="最小" disabled={!aiReviewPageLimitOnWatch} />
                                        </Form.Item>
                                        <span>～</span>
                                        <Form.Item name={['aiReviewSettings', 'pageNumMax']} noStyle>
                                            <Input style={{ width: 72 }} placeholder="最大" disabled={!aiReviewPageLimitOnWatch} />
                                        </Form.Item>
                                        <span>页</span>
                                    </Space>
                                </div>
                                <div style={{ marginBottom: 12 }}>
                                    <Space align="center" wrap>
                                        <Form.Item name={['aiReviewSettings', 'templateOn']} valuePropName="checked" noStyle>
                                            <Switch checkedChildren="开启" unCheckedChildren="关闭" onChange={handleAiReviewTemplateOnChange} />
                                        </Form.Item>
                                        <span>文档使用统一实践模板：</span>
                                        <Upload accept=".pptx,application/vnd.openxmlformats-officedocument.presentationml.presentation" showUploadList={false} beforeUpload={beforeUploadAiReviewTemplate} disabled={!aiReviewTemplateOnWatch} customRequest={aiReviewTemplateUpload.customRequest}>
                                            <Button disabled={!aiReviewTemplateOnWatch}>{aiReviewTemplatePathWatch ? '重新上传' : '上传模板'}</Button>
                                        </Upload>
                                        <Form.Item name={['aiReviewSettings', 'template']} hidden>
                                            <Input />
                                        </Form.Item>
                                        {aiReviewTemplatePathWatch ? (
                                            <a href={prepareBCOSSUrl(aiReviewTemplatePathWatch)} rel="noopener noreferrer" onClick={handleAiReviewTemplateDownload}>
                                                下载模板
                                            </a>
                                        ) : null}
                                    </Space>
                                    <div className="ant-form-item-extra" style={{ marginTop: 4, clear: 'both' }}>
                                        实践模板文件支持 pptx 格式，大小不超过 20MB
                                    </div>
                                </div>
                                <div>
                                    <Space align="center">
                                        <Form.Item name={['aiReviewSettings', 'duplicateOn']} valuePropName="checked" noStyle>
                                            <Switch checkedChildren="开启" unCheckedChildren="关闭" onChange={handleAiReviewDuplicateOnChange} />
                                        </Form.Item>
                                        <span>同一评议项目中实践不得重复</span>
                                    </Space>
                                </div>
                            </div>
                        </div>
                    </Form.Item>

                    <Form.Item className="required" label="投票按钮等待时长" help="默认0秒，不用等待即可点击投票按钮，最小0秒，最大30秒">
                        <Space>
                            <Form.Item name="voteWaitDuration" label="投票按钮等待时长" noStyle rules={[{ required: true, pattern: /^30$|^([1-2]\d)$|^\d?$/ }]}>
                                <Input style={{ width: 60 }} />
                            </Form.Item>
                            <span>秒</span>
                        </Space>
                    </Form.Item>

                    <Form.Item className="required" label="每人每天可投票">
                        <Space>
                            <Form.Item
                                name="dailyVoteLimit"
                                noStyle
                                rules={[
                                    { required: true, message: '请输入每人每天可投票' },
                                    { pattern: /^\+?[1-9]\d*$/, message: '请输入大于0的正整数' },
                                ]}
                            >
                                <Input style={{ width: 60 }} />
                            </Form.Item>
                            <span>次</span>
                        </Space>
                    </Form.Item>

                    <Form.Item name="dailyMultiVoteEnabled" label="同一实践可重复投票" valuePropName="checked">
                        <Switch checkedChildren="开" unCheckedChildren="关" />
                    </Form.Item>

                    <Form.Item label="同主题可投票实践数" name="topicVoteLimit">
                        <Radio.Group value={topicCount} onChange={handleChangeRadio}>
                            <Radio value={0}>不限数量</Radio>
                            <Radio value={1}>
                                <span>
                                    <span>限&nbsp;</span>
                                    <Form.Item
                                        name="edit"
                                        noStyle
                                        rules={[
                                            { required: topicCount === 1, message: '请输入同主题可投票实践数' },
                                            { pattern: /^\+?[1-9]\d*$/, message: '请输入大于0的正整数' },
                                        ]}
                                    >
                                        <Input style={{ width: 60 }} />
                                    </Form.Item>
                                    <span>&nbsp;个</span>
                                </span>
                            </Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="同主题可提交实践数" name="topicCaseNumLimit">
                        <Radio.Group value={topicCaseNumCount} onChange={handleChangeTopicCaseNumRadio}>
                            <Radio value={0}>不限数量</Radio>
                            <Radio value={1}>
                                <span>
                                    <span>限&nbsp;</span>
                                    <Form.Item
                                        name="topicCaseNumEdit"
                                        noStyle
                                        rules={[
                                            { required: topicCaseNumCount === 1, message: '请输入同主题可提交实践数' },
                                            { pattern: /^\+?[1-9]\d*$/, message: '请输入大于0的正整数' },
                                        ]}
                                    >
                                        <Input style={{ width: 60 }} />
                                    </Form.Item>
                                    <span>&nbsp;个</span>
                                </span>
                            </Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item name="competitionCertificateUrl" label="申报证书背景图" help="图片尺寸 1754*1240px，支持 JPG/PNG格式，大小不超过5MB" className="share-image">
                        {competitionList.length > 0 && (
                            <>
                                <Image width={200} src={competitionList[0]} className="share-image-area" alt="申报证书背景图预览" />
                                <span onClick={() => closeImg(1)} className="close-img">
                                    <i className="bi bi-x-lg" />
                                </span>
                            </>
                        )}
                        <div>
                            <ImgCrop
                                aspect={1754 / 1240}
                                minZoom={0.1}
                                maxZoom={2}
                                quality={1}
                                beforeCrop={async file => {
                                    const res = await beforeCropCheck(file, true, 5, 'bg');
                                    return res;
                                }}
                            >
                                <Upload beforeUpload={file => checkout(file, 5, 300, 300)} fileList={judgesList} {...competitionImageFile} maxCount={1}>
                                    <Button icon={<i className="bi bi-upload" />}>{competitionList.length > 0 ? '更改背景' : '上传背景'}</Button>
                                </Upload>
                            </ImgCrop>
                            <Button onClick={() => viewTemplateImg(1)} type="link" style={{ marginLeft: '30px' }}>
                                示例模板
                            </Button>
                        </div>
                    </Form.Item>

                    <Form.Item name="judgesAppointmentUrl" label="评议专家聘书背景图" help="图片尺寸 1754*1240px，支持 JPG/PNG格式，大小不超过5MB" className="share-image">
                        {judgesList.length > 0 && (
                            <>
                                <Image width={200} src={judgesList[0]} className="share-image-area" alt="评议专家聘书背景图预览" />
                                <span onClick={() => closeImg(2)} className="close-img">
                                    <i className="bi bi-x-lg" />
                                </span>
                            </>
                        )}
                        <div>
                            <ImgCrop
                                aspect={1754 / 1240}
                                minZoom={0.1}
                                maxZoom={2}
                                quality={1}
                                beforeCrop={async file => {
                                    const res = await beforeCropCheck(file, true, 5, 'bg');
                                    return res;
                                }}
                            >
                                <Upload beforeUpload={file => checkout(file, 5, 300, 300)} fileList={judgesList} {...judgesImageFile} maxCount={1}>
                                    <Button icon={<i className="bi bi-upload" />}>{judgesList.length > 0 ? '更改背景' : '上传背景'}</Button>
                                </Upload>
                            </ImgCrop>
                            <Button onClick={() => viewTemplateImg(2)} type="link" style={{ marginLeft: '30px' }}>
                                示例模板
                            </Button>
                        </div>
                    </Form.Item>

                    <Form.Item name="awardCertificateTemplate" label="评议结果证书背景图" help="请按A3大小（420*297毫米）设计背景，支持 JPG/PNG格式，大小不超过10MB" className="share-image">
                        {certifiList.length > 0 && (
                            <>
                                <Image width={200} src={certifiList[0]} className="share-image-area" alt="评议结果证书背景图预览" />
                                <span onClick={() => closeImg(3)} className="close-img">
                                    <i className="bi bi-x-lg" />
                                </span>
                            </>
                        )}
                        <div>
                            <Upload beforeUpload={file => checkout(file, 10, 300, 300)} fileList={certifiList} {...certifiFile} maxCount={1}>
                                <Button icon={<i className="bi bi-upload" />}>{certifiList.length > 0 ? '更改背景' : '上传背景'}</Button>
                            </Upload>
                            <Button onClick={() => viewTemplateImg(3)} type="link" style={{ marginLeft: '30px' }}>
                                示例模板
                            </Button>
                        </div>
                    </Form.Item>

                    <Form.Item name="shareTitle" label="微信分享标题" rules={[{ required: true, message: '' }]}>
                        <Input placeholder="输入分享标题" maxLength={30} showCount allowClear />
                    </Form.Item>

                    <Form.Item name="shareDesc" label="微信分享描述" rules={[{ required: true, message: '' }]}>
                        <Input placeholder="输入分享描述" maxLength={30} showCount allowClear />
                    </Form.Item>

                    <Form.Item name="sharePic" label="微信分享图" rules={[{ required: true, message: '' }]} help="支持JPG/PNG格式，尺寸300&times;300px，大小不超过2M" className="share-image">
                        {fileList.length > 0 && <Image width={200} src={fileList[0]} className="share-image-area" alt="微信分享图预览" />}

                        <div>
                            <Upload beforeUpload={file => checkout(file, 2, 300, 300)} fileList={fileList} {...shareImageFile} maxCount={1}>
                                <Button icon={<i className="bi bi-upload" />}>{fileList.length > 0 ? '更改图片' : '上传图片'}</Button>
                            </Upload>
                        </div>
                    </Form.Item>

                    <div className="page-form-foot-operations">
                        <Space size="large">
                            <Button type="primary" size="large" htmlType="submit">
                                提交
                            </Button>
                            <Button type="default" size="large" onClick={onReset}>
                                取消
                            </Button>
                        </Space>
                    </div>
                </Form>

                <Modal title="示例模板" centered open={isShowTemplate} width={980} footer={null} onCancel={() => setIsShowTemplate(false)} styles={{ body: { padding: 0 } }}>
                    <div>
                        <Image width={980} height={695} src={getViewImg()} alt="证书背景示例模板" />
                    </div>
                </Modal>
            </div>
        </Fragment>
    );
};

export default Project;
